// TMDb API Configuration
export const TMDB_API_KEY = process.env.REACT_APP_TMDB_API_KEY;
export const TMDB_BASE_URL = "https://api.themoviedb.org/3";
export const TMDB_IMAGE_BASE_URL = "https://image.tmdb.org/t/p/w500"; // Base URL for movie posters
export const TMDB_PROFILE_BASE_URL = "https://image.tmdb.org/t/p/w185"; // Base URL for actor profiles (small)
export const TMDB_LARGE_PROFILE_BASE_URL = "https://image.tmdb.org/t/p/w500"; // Base URL for larger actor profiles
export const TMDB_BACKDROP_BASE_URL = "https://image.tmdb.org/t/p/w1280"; // Base URL for movie backdrops

if (!TMDB_API_KEY) {
  // eslint-disable-next-line no-console
  console.warn('Warning: REACT_APP_TMDB_API_KEY is not set in your environment variables. API requests will fail.');
}
